// Set a URL to replace the CSS placeholders with real images.
export const MEDIA = {
  bookCover: "https://customer-assets-eiarnc6j.emergentagent.net/job_d8527284-bd0a-4336-af81-3682ddb8fd0d/artifacts/dd376e9c9ad31a4d_WhatsApp%20Image%202026-10-01%20at%2014.24.40.jpeg",
  authorPhoto: "https://customer-assets-eiarnc6j.emergentagent.net/job_d8527284-bd0a-4336-af81-3682ddb8fd0d/artifacts/2adca33824a60e2e_WhatsApp%20Image%202026-10-02%20at%2012.37.35.jpeg",
};
